export function formatCard(value) {
  if (!value) return null;
  return "**** **** **** " + value.substring(12);
}

export function newFormatCard(value) {
  if (!value) return null;
  return "Card Ending " + value.substring(12);
}
